var _rect, _circle, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDragZoom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 199,
    height: 197,
    viewBox: "0 0 199 197",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 138.217,
    y: 112.328,
    width: 85.3994,
    height: 34.0487,
    transform: "rotate(45 138.217 112.328)",
    fill: "#808BA4"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 80.5,
    cy: 80.5,
    r: 80.5,
    fill: "#808BA4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 36,
    width: 87,
    height: 88,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 49,
    width: 63,
    height: 62,
    fill: "#808BA4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDragZoom);
export default __webpack_public_path__ + "static/media/icon-drag-zoom.ce4837201ecb142b9620d86f042d891b.svg";
export { ForwardRef as ReactComponent };